import { cn } from '@/utils/cn'

export function MeetingDatetimeTimeGrid({
  label,
  options,
  selected,
  disabledOption,
  onSelect,
  onBlocked,
  formatOption,
}: {
  label: string
  options: number[]
  selected: number
  disabledOption?: (option: number) => boolean
  onSelect: (value: number) => void
  onBlocked?: () => void
  formatOption: (value: number) => string
}) {
  return (
    <div className="flex min-w-0 flex-1 flex-col gap-1.5">
      <p className="text-center text-[10px] font-bold uppercase tracking-wider text-text-muted">
        {label}
      </p>
      <div className="grid max-h-28 grid-cols-4 gap-0.5 overflow-y-auto overscroll-contain rounded-lg border border-white/[0.06] bg-white/[0.02] p-1 scrollbar-thin">
        {options.map((option) => {
          const active = option === selected
          const blocked = disabledOption?.(option) ?? false
          return (
            <button
              key={option}
              type="button"
              aria-disabled={blocked}
              onClick={() => {
                if (blocked) {
                  onBlocked?.()
                  return
                }
                onSelect(option)
              }}
              className={cn(
                'rounded-md py-1.5 text-[11px] font-semibold transition-colors',
                blocked && 'cursor-not-allowed opacity-30',
                active && !blocked
                  ? 'bg-accent text-white'
                  : blocked
                    ? 'text-text-muted'
                    : 'text-text-secondary hover:bg-white/[0.08] hover:text-text-primary',
              )}
            >
              {formatOption(option)}
            </button>
          )
        })}
      </div>
    </div>
  )
}
